<template>

     <el-dialog  style="text-align: center" title="修改文章状态" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
               :close-on-press-escape="false">       
        <div style="margin: 20px;text-align: center;">
            <el-radio-group v-model="article_status">
                <el-radio  label="0" >隐藏</el-radio>
                <el-radio  label="1" >显示</el-radio>
            </el-radio-group>
        </div>
        <el-button  type="primary"  style="margin-top: 12px;text-align: center;" @click="changeStatus">确定</el-button>
    </el-dialog>
</template>

<script>
    import ArticleApi from "@/api/article.js";
    export default {
        data() {
            return {
                /*是否显示*/
                loading: false,
                dialogVisible: false,
                article_status:0
            };
        },
        props: ['open_state', 'select_list'],
        created() {
            console.log(this.open_state,this.select_list)
            this.dialogVisible = this.open_state;
        },
        methods: {
            changeStatus()
            {
                let self = this;
                let ids = this.select_list
                let status = this.article_status
                let Params = {};
                Params.ids = ids;
                Params.status = status;

                ArticleApi.setStatusList(Params, true).then(data => {
                    self.$message({
                      message: '修改成功',
                      type: 'success'
                    });
                    // self.dialogFormVisible(true);
                    window.location.reload();
                }).catch(error => {

                });

            },
            /*关闭弹窗*/
            dialogFormVisible(e) {
                if (e) {
                    this.$emit('closeDialog', {
                        type: 'success',
                        openDialog: false
                    })
                } else {
                    this.$emit('closeDialog', {
                        type: 'error',
                        openDialog: false
                    })

                }

               
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/plus/salestarget/target/dialog/State.vue